'use client';
import PageLayout from '../PageLayout';
import { useTranslation } from 'react-i18next';
import { defaultLang, SUPPORTED } from '../../config/languages';
import { useParams } from 'next/navigation';
import PricingLayout2 from './Layout2';

export default function Pricing() {
  const { t } = useTranslation('pricing');
  const { lang = defaultLang } = useParams();
  const activeLang = SUPPORTED.includes(lang) ? lang : defaultLang;

  return (
    <PageLayout
      presentLikeHome
      title={t('pageTitle')}
      metaDescription={t('pageMetaDescription')}
      canonical={`https://www.adcast.app${activeLang === 'en' ? '' : '/' + activeLang}/pricing`}
    >
      <PricingLayout2 />
    </PageLayout>
  );
}
